import React from 'react'
import { ApplicantColumns } from 'constants/application'
import AuthService from 'tools/AuthService'
import { OnboardedToFC } from 'constants/chartData'
import PrepareTooltip from 'components/shared/Tooltip'
import Tooltip from '@material-ui/core/Tooltip'
import Archive from '@material-ui/icons/Archive'

export function buildApplicantColumns({
                                          showFactorCloudOnboardColumn,
                                          onArchiveClick,
                                          onRedirectFCClick,
                                          onOnboardingErrorClick
                                      }) {
    const COLUMN_TO_HIDE = 'factorCloudStatus'

    // Filter columns based on showFactorCloudOnboardColumn
    let columns = showFactorCloudOnboardColumn
        ? [...ApplicantColumns]
        : ApplicantColumns.filter(col => col.dataField !== COLUMN_TO_HIDE)

    // Remove riskScore column if present
    columns = columns.filter(col => col.dataField !== 'riskScore')

    // Add FactorCloud status formatter
    columns = columns.map(col => {
        if (col.dataField === 'factorCloudStatus') {
            return {
                ...col,
                formatter: (cell, row) => {
                    const status = OnboardedToFC.find((st) => st.status === cell)
                    if (!status) return null

                    const isClickable = status.abbreviation === "Onboarded" || status.abbreviation === "Onboarding Error"

                    const handleClick = () => {
                        if (status.abbreviation === "Onboarded") {
                            onRedirectFCClick(row)
                        } else if (status.abbreviation === "Onboarding Error") {
                            onOnboardingErrorClick(row)
                        }
                    }

                    return (
                        <PrepareTooltip title={status.tooltip} theme="white">
                            <div
                                className="table-label"
                                style={{
                                    background: status.code,
                                    color: status.color,
                                    cursor: isClickable ? "pointer" : "default",
                                }}
                                onClick={handleClick}
                            >
                                {status.abbreviation}
                            </div>
                        </PrepareTooltip>
                    )
                }
            }
        }
        return col
    })

    // Add archive action formatter if user has privilege
    if (AuthService.hasPrivilege('ARCHIVE_APPLICATION')) {
        columns = columns.map(col => {
            if (col.dataField === 'action') {
                return {
                    ...col,
                    formatter: (cell, row) => (
                        <Tooltip title="Archive Application">
                            <Archive className='action-icon' onClick={() => onArchiveClick(row)} />
                        </Tooltip>
                    )
                }
            }
            return col
        })
    }

    return columns
}